import React from 'react';
import style from './Info.style';


const InfoNote = ({text}) => (
    <p className={style.info_note}>{text}</p>
);

export default InfoNote;